module.exports = __webpack_public_path__ + "static/media/cal.e0cf7ce9.svg";